export const DISTANCE_UNITS = {
  feet: {
    label: 'Feet',
    shortLabel: 'ft',
    singular: 'foot',
    plural: 'feet',
    feetMultiplier: 1,
    defaultValue: '200',
    step: '1',
    min: '1'
  },
  miles: {
    label: 'Miles',
    shortLabel: 'mi',
    singular: 'mile',
    plural: 'miles',
    feetMultiplier: 5280,
    defaultValue: '0.25',
    step: '0.01',
    min: '0.01'
  },
  meters: {
    label: 'Meters',
    shortLabel: 'm',
    singular: 'meter',
    plural: 'meters',
    feetMultiplier: 3.28084,
    defaultValue: '60',
    step: '1',
    min: '1'
  },
  kilometers: {
    label: 'Kilometers',
    shortLabel: 'km',
    singular: 'kilometer',
    plural: 'kilometers',
    feetMultiplier: 3280.84,
    defaultValue: '0.4',
    step: '0.01',
    min: '0.01'
  }
};

export const DISTANCE_UNIT_OPTIONS = Object.entries(DISTANCE_UNITS).map(([value, unit]) => ({
  value,
  label: unit.label
}));

export const getDistanceUnit = (unit) => DISTANCE_UNITS[unit] || DISTANCE_UNITS.feet;

export const convertDistanceToFeet = (value, unit) => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return null;
  }

  return Math.max(1, Math.round(numericValue * getDistanceUnit(unit).feetMultiplier));
};

export const formatDistance = (value, unit = 'feet') => {
  const numericValue = Number(value);
  const distanceUnit = getDistanceUnit(unit);

  if (!Number.isFinite(numericValue)) {
    return '';
  }

  const formattedValue = unit === 'feet'
    ? String(Math.round(numericValue))
    : numericValue.toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: numericValue % 1 === 0 ? 0 : 1
      });

  return `${formattedValue} ${numericValue === 1 ? distanceUnit.singular : distanceUnit.plural}`;
};

export const getSavedDistanceValue = (location) => {
  if (location?.requiredDistanceValue !== undefined && location?.requiredDistanceValue !== null) {
    return String(location.requiredDistanceValue);
  }

  return String(location?.requiredDistance || DISTANCE_UNITS.feet.defaultValue);
};

export const getSavedDistanceUnit = (location) => {
  if (DISTANCE_UNITS[location?.requiredDistanceUnit]) {
    return location.requiredDistanceUnit;
  }

  return 'feet';
};

export const formatLocationRadius = (location) => {
  const unit = getSavedDistanceUnit(location);
  const savedValue = Number(location?.requiredDistanceValue);
  const feetValue = Number(location?.requiredDistance);
  const hasSavedValue = Number.isFinite(savedValue) && savedValue > 0;
  const hasFeetValue = Number.isFinite(feetValue) && feetValue > 0;
  const value = hasSavedValue
    ? savedValue
    : hasFeetValue
      ? feetValue / getDistanceUnit(unit).feetMultiplier
      : DISTANCE_UNITS[unit].defaultValue;

  return `${formatDistance(value, unit)} required radius`;
};
